var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"copyright-info"},[_vm._v(" ©2025 ACSL CFLS&CyberCo Club All Rights Reserved. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }